import { Rank } from '../../sim/defs';
import { Fam } from '../../sim/pools/BulletPool';
import { defineEnemy, Motion, Pattern } from '../schema';

/* ═══════════════════════════════════════════════════════════════════════════
   NEF — la PLATEFORME VOLANTE ennemie, version SHOOTABLE.

   Le pendant « ennemi » du radeau (l'obstacle indestructible) : une barge large
   qui LOUVOIE lentement en descendant (`Motion.Sine`, prévisible), hérissée de
   deux AFFÛTS. Contrairement au radeau, on peut l'ABATTRE — mais elle est
   `shieldedByParts` : ses tourelles (deux Éclats montés) protègent la plateforme.
   On démonte d'abord les canons, puis la nef s'expose et lâche son éventail de
   couverture. Ses tourelles la CHEVAUCHENT gratuitement — le système de parties
   les reposionne sur le porteur mobile à chaque tick, exactement comme sur un boss.

   ── Pourquoi elle se lit comme une plateforme, pas comme un gros ennemi ──
   Sa silhouette (archétype `nef` : deux ponts, une aire annulaire, des affûts) est
   la plus LARGE et la plus HORIZONTALE du bestiaire, et son louvoiement lent la
   pose comme une structure qui traverse. La menace est ses canons et son
   encombrement mobile, jamais une charge.

   ── Points de vie ──
   Corps 280, deux tourelles Éclat (45 chacune) : ~370 au total, entre le Mortier et
   une élite. Le monde qui la reçoit multiplie tout par son coefficient.
   ═══════════════════════════════════════════════════════════════════════════ */

export default defineEnemy({
  id: 'nef',
  rank: Rank.Heavy,
  hp: 280,
  visualRadius: 62,
  score: 900,
  // Une grosse structure : elle s'annonce. Ses tourelles héritent du télégraphe.
  telegraph: 1.0,
  drops: 5,
  // Louvoiement lent et ample en descendant : on anticipe où elle sera, comme le
  // pilotage du Héraut. La descente est douce (70 u/s), l'oscillation large.
  motion: { kind: Motion.Sine, speed: 70, amplitude: 150, frequency: 0.5, holdY: 0 },
  emitter: {
    // Éventail STATIQUE lent : la plateforme couvre une zone, elle ne vise pas. La
    // menace dirigée passe par les affûts (Éclats visés) et disparaît avec eux.
    pattern: Pattern.Fan,
    every: 3.0,
    count: 7,
    spreadDeg: 120,
    speed: 240,
    firstDelay: 1.5,
    family: Fam.EnemyRed,
  },
  // Les deux AFFÛTS, aux emplacements des pods de la silhouette. Des Éclats
  // ordinaires — une tourelle est un ennemi comme un autre, qui se trouve monté.
  parts: [
    { enemy: 'eclat', offX: -48, offY: 6 },
    { enemy: 'eclat', offX: 48, offY: 6 },
  ],
  // Intouchable tant qu'un affût vit : on démonte les canons, puis la plateforme.
  // Si le pool sature et qu'aucune tourelle n'apparaît, `livingParts` renvoie zéro
  // et la nef redevient vulnérable — diminuée, jamais invincible.
  shieldedByParts: true,
});
